export default function VerificationBadge({ label = "Verified source" }) {
  return (
    <span className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-black text-emerald-800">
      <span className="h-2 w-2 rounded-full bg-emerald-500" aria-hidden="true" />
      {label}
    </span>
  );
}
